import createHmac from 'crypto-js/hmac-sha256';
import { MouseEvent } from "react";

import { DataToSign } from '../fkc/fkc.types';

import { SweepSubmissionEntries } from "./types";

export function handleGoogleDriveImageUrl(mediaUrl?: string | null) {
  if (mediaUrl?.includes("https://drive.google.com/file/")) {
    return mediaUrl.replace(
      /.*\/file\/d\/(.*)\/view\?usp=sharing.*/gi,
      "https://drive.google.com/uc?export=view&id=$1"
    );
  }
  return mediaUrl ?? "";
}

export function handleGoogleDriveVideoUrl(mediaUrl: string) {
  if (mediaUrl.includes("https://drive.google.com/file/")) {
    return mediaUrl.replace(
      /.*\/file\/d\/(.*)\/view\?usp=sharing.*/gi,
      "https://drive.google.com/uc?export=download&id=$1"
    );
  }
  return mediaUrl;
}

export function shufleArray(array: any[]) {
  let currentIndex = array.length,
    temporaryValue,
    randomIndex;
  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}

export function handleAssetUrl(asset: string) {
  if (window.FKL.assetWidgetUrl) {
    return window.FKL.assetWidgetUrl.replace("$asset$", asset);
  }
  return asset;
}

export function retrieveFromSessionStorage(key: string) {
  return sessionStorage.getItem(key);
}

export function saveInSessionStorage(key: string, value: any) {
  sessionStorage.setItem(key, value);
}

export function isDefined<T>(value: T | undefined | null): value is T {
  return <T>value !== undefined && <T>value !== null;
}

export function handlePrizeVaultModalBtnClick(event: MouseEvent) {
  event.preventDefault();
  document
    .querySelector("#arcadeModalPrizeVault")!
    .classList.toggle("show-modal");
}

export function handleChooseGameModalBtnClick(event: MouseEvent) {
  event.preventDefault();
  document
    .querySelector("#arcadeModalChooseGame")!
    .classList.toggle("show-modal");
}

export function validatePhoneNumber(phoneNumber: string): boolean {
  return /^\([0-9]{3}\)\s[0-9]{3}-[0-9]{4}$/.test(phoneNumber);
}

export const URL_REGEX =
  /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})*([/\w\-._~:?#[\]@!$&'()*+,;=]*)?$/;

export function getTotalSweepEntries(
  sweepSubmissionEntries: SweepSubmissionEntries | null = {},
  excludedEntries: string[] = []
): number {
  const {
    submissionCount = 1,
    quizExtraEntries = 0,
    cplExtraEntries = 0,
    referralExtraEntries = 0,
    smsExtraEntries = 0,
  } = sweepSubmissionEntries || {};

  const entriesObj: SweepSubmissionEntries = {
    submissionCount,
    quizExtraEntries,
    cplExtraEntries,
    referralExtraEntries,
    smsExtraEntries,
  };

  return Object.keys(entriesObj).reduce(
    (acc, key) =>
      acc +
      Number(
        excludedEntries.includes(key)
          ? 0
          : entriesObj[key as keyof SweepSubmissionEntries]
      ),
    0
  );
}

export function getArcadeGameImageUrl(
  availableGames: ArcadeGameInfo[],
  currentLocation: string
): string {
  return (
    availableGames
      .filter((selectedGame) => selectedGame.url === currentLocation)
      .map((selectedGame) => selectedGame.modalImageUrl)[0] || ""
  );
}

export const pluralizeEntries = (entries: string): string => {
  return entries && +entries > 1 ? "entries" : "entry";
};

export function createHmacSignature({ payload = "", params = {} }: DataToSign, secret: string): string {
  const urlParams = new URLSearchParams(params).toString();
  const decodedParams = decodeURIComponent(urlParams);
  return createHmac(payload + decodedParams, secret).toString();
}

export function getEnvironment(): "staging" | "production" {
  return window.FKL.yentaServicesApiUrl.includes("staging") ? "staging" : "production";
}
